import styled from 'styled-components';
import { px } from '../../utils';
import { LIST_ITEM_BULLET_POINT_SIZE, LIST_ITEM_BULLET_POINT_SPACING } from './UnorderedListItem.constants';
export const UnorderedListItem = styled.li.withConfig({
  componentId: "ds__sc-1rlhv3g-0"
})(["", ";"], props => props.listImage ? `
        text-indent: 0px;
        background: url('${props.listImage}') no-repeat left top;
        list-style: none;
        padding: 0 0 32px 36px;
        margin: 0;
        ` : `
        position: relative;

        padding-left: ${px(LIST_ITEM_BULLET_POINT_SIZE + LIST_ITEM_BULLET_POINT_SPACING)};
        margin-bottom: ${props.spacing ? px(props.spacing) : 0};
        line-height: ${props.lineHeight ? px(props.theme.UnorderedList.LIST_ITEM_SIZE_TO_LINE_HEIGHT[props.lineHeight]) : '1.5rem'};

        &:before {
          position: absolute;
          left: 0;

          width: ${px(LIST_ITEM_BULLET_POINT_SIZE)};
          height: ${px(LIST_ITEM_BULLET_POINT_SIZE)};

          content: "${props.theme.UnorderedList.ListItem.character}";
          text-align: center;
          color: ${props.theme.UnorderedList.ListItem.color};
        }`);